var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_9728)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.719,
    cy: 270.418,
    r: 125.583,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.718,
    cy: 270.418,
    r: 83.2817,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 209.519,
    cy: 266.452,
    r: 29.0822,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43 219.73C148.918 221.926 107.013 162.825 100 133H430.064C401.792 196.675 352.479 219.73 260.43 219.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 133C107.013 162.825 148.918 221.926 260.43 219.73C352.479 219.73 401.792 196.675 430.064 133",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.374557,
    cy: 525.941,
    rx: 141.448,
    ry: 77.9406,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.975 487.023L417.161 434.209",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.667,
    cy: 353.667,
    r: 94.1668,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.596 398.845C348.913 400.312 354.245 406.03 356.94 410.262C357.075 410.476 357.196 410.698 357.301 410.927C361.282 419.633 369.321 420.627 372.554 420.139C375.553 419.686 378.35 421.75 378.803 424.748C379.256 427.746 377.192 430.544 374.194 430.997C367.871 431.952 354.213 430.078 347.493 415.878C345.539 412.934 342.466 410.219 339.438 409.612C337.178 409.159 332.954 409.516 327.489 417.764C325.814 420.292 322.407 420.983 319.879 419.309C317.351 417.634 316.66 414.227 318.335 411.699C325.259 401.25 333.414 397.205 341.596 398.845Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.326 334.592C408.817 330.626 407.479 324.609 407.313 320.777C407.302 320.525 407.309 320.272 407.332 320.021C407.906 313.977 403.838 310.939 402.033 310.232C399.21 309.125 397.819 305.939 398.926 303.116C400.033 300.293 403.219 298.901 406.042 300.009C410.753 301.856 419.243 308.458 418.302 320.621C418.468 322.948 419.337 325.255 420.578 326.347C421.214 326.906 423.282 328.383 429.39 325.342C432.104 323.99 435.4 325.095 436.752 327.809C438.103 330.524 436.999 333.82 434.284 335.171C425.813 339.39 418.497 339.141 413.326 334.592Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.434 276.546C347.155 276.546 351.792 280.184 351.792 284.673L351.792 295.509C351.792 299.997 347.155 303.635 341.434 303.635C335.714 303.635 331.077 299.997 331.077 295.509L331.077 284.673C331.077 280.184 335.714 276.546 341.434 276.546Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.434 359.408C347.155 359.408 351.792 363.475 351.792 368.491L351.792 380.602C351.792 385.618 347.155 389.685 341.434 389.685C335.714 389.685 331.077 385.618 331.077 380.602L331.077 368.491C331.077 363.475 335.714 359.408 341.434 359.408Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.115 292.371C384.599 295.855 384.599 301.504 381.115 304.989L372.703 313.401C369.218 316.885 363.569 316.885 360.085 313.401C356.6 309.916 356.6 304.267 360.085 300.783L368.497 292.371C371.981 288.886 377.63 288.886 381.115 292.371Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.389 352.093C324.874 355.578 324.874 361.227 321.389 364.711L312.977 373.123C309.493 376.608 303.843 376.608 300.359 373.123C296.875 369.639 296.875 363.99 300.359 360.505L308.771 352.093C312.255 348.609 317.905 348.609 321.389 352.093Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.688 292.37C304.172 288.885 309.821 288.885 313.306 292.37L321.718 300.782C325.202 304.266 325.202 309.915 321.718 313.4C318.234 316.884 312.584 316.884 309.1 313.4L300.688 304.988C297.203 301.503 297.203 295.854 300.688 292.37Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.412 352.092C363.896 348.608 369.546 348.608 373.03 352.092L381.442 360.504C384.927 363.989 384.927 369.638 381.442 373.123C377.958 376.607 372.309 376.607 368.824 373.123L360.412 364.71C356.928 361.226 356.928 355.577 360.412 352.092Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.865 331.525C284.865 326.684 288.503 322.761 292.992 322.761L303.827 322.761C308.316 322.761 311.954 326.684 311.954 331.525C311.954 336.365 308.316 340.289 303.827 340.289L292.992 340.289C288.503 340.289 284.865 336.365 284.865 331.525Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.727 331.525C367.727 326.684 371.794 322.761 376.81 322.761L388.921 322.761C393.937 322.761 398.004 326.684 398.004 331.525C398.004 336.365 393.937 340.289 388.921 340.289L376.81 340.289C371.794 340.289 367.727 336.365 367.727 331.525Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.288 332.322C377.288 352.563 360.879 368.972 340.638 368.972C320.396 368.972 303.987 352.563 303.987 332.322C303.987 312.08 320.396 295.671 340.638 295.671C360.879 295.671 377.288 312.08 377.288 332.322Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.291 320.787C360.291 326.795 355.421 331.666 349.413 331.666C343.405 331.666 338.534 326.795 338.534 320.787C338.534 314.779 343.405 309.908 349.413 309.908C355.421 309.908 360.291 314.779 360.291 320.787Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.083 343.995C337.083 348.401 333.511 351.973 329.105 351.973C324.699 351.973 321.127 348.401 321.127 343.995C321.127 339.589 324.699 336.018 329.105 336.018C333.511 336.018 337.083 339.589 337.083 343.995Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.519 356.612C440.519 361.464 436.832 365.397 432.283 365.397C427.735 365.397 424.047 361.464 424.047 356.612C424.047 351.76 427.735 347.827 432.283 347.827C436.832 347.827 440.519 351.76 440.519 356.612Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.104 279.196C391.104 282.531 388.4 285.235 385.064 285.235C381.729 285.235 379.025 282.531 379.025 279.196C379.025 275.86 381.729 273.156 385.064 273.156C388.4 273.156 391.104 275.86 391.104 279.196Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.211 361.23C411.127 361.23 413.492 363.086 413.492 365.374L413.492 370.899C413.492 373.187 411.127 375.042 408.211 375.042C405.294 375.042 402.93 373.187 402.93 370.899L402.93 365.374C402.93 363.086 405.294 361.23 408.211 361.23Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.211 403.479C411.127 403.479 413.492 405.552 413.492 408.109L413.492 414.284C413.492 416.842 411.127 418.915 408.211 418.915C405.294 418.915 402.93 416.842 402.93 414.284L402.93 408.109C402.93 405.552 405.294 403.479 408.211 403.479Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.442 369.298C430.219 371.074 430.219 373.955 428.442 375.731L424.153 380.02C422.377 381.797 419.497 381.797 417.72 380.02C415.943 378.243 415.943 375.363 417.72 373.587L422.009 369.298C423.785 367.521 426.666 367.521 428.442 369.298Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.991 399.75C399.768 401.526 399.768 404.407 397.991 406.183L393.702 410.472C391.926 412.249 389.045 412.249 387.269 410.472C385.492 408.696 385.492 405.815 387.269 404.039L391.558 399.75C393.334 397.973 396.215 397.973 397.991 399.75Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.436 369.298C389.213 367.521 392.093 367.521 393.87 369.298L398.158 373.587C399.935 375.363 399.935 378.244 398.158 380.02C396.382 381.797 393.502 381.797 391.725 380.02L387.436 375.731C385.66 373.955 385.66 371.074 387.436 369.298Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.887 399.749C419.663 397.973 422.543 397.973 424.32 399.749L428.609 404.038C430.385 405.815 430.385 408.695 428.609 410.471C426.832 412.248 423.952 412.248 422.176 410.471L417.887 406.183C416.11 404.406 416.11 401.526 417.887 399.749Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.369 389.261C379.369 386.793 381.224 384.793 383.512 384.793H389.037C391.325 384.793 393.181 386.793 393.181 389.261C393.181 391.729 391.325 393.729 389.037 393.729H383.512C381.224 393.729 379.369 391.729 379.369 389.261Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.616 389.261C421.616 386.793 423.69 384.793 426.247 384.793H432.422C434.98 384.793 437.053 386.793 437.053 389.261C437.053 391.729 434.98 393.729 432.422 393.729H426.247C423.69 393.729 421.616 391.729 421.616 389.261Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.491 389.667C426.491 399.987 418.125 408.353 407.805 408.353C397.484 408.353 389.118 399.987 389.118 389.667C389.118 379.347 397.484 370.98 407.805 370.98C418.125 370.98 426.491 379.347 426.491 389.667Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.643 384.209C418.643 387.41 416.048 390.004 412.847 390.004C409.647 390.004 407.052 387.41 407.052 384.209C407.052 381.008 409.647 378.413 412.847 378.413C416.048 378.413 418.643 381.008 418.643 384.209Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.279 396.573C406.279 398.921 404.376 400.824 402.029 400.824C399.682 400.824 397.779 398.921 397.779 396.573C397.779 394.226 399.682 392.323 402.029 392.323C404.376 392.323 406.279 394.226 406.279 396.573Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_9728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_세균성 안검염.e3f6d5d17a9fbd793667be84978bcee7.svg";
export { ForwardRef as ReactComponent };